module.exports = __webpack_public_path__ + "static/img/coupon_bg_en.637c38d0.png";